var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value: _vm.visible,
          expression: "visible",
        },
      ],
      staticClass: "modal",
    },
    [
      _c("div", { staticClass: "modal-body" }, [
        _c("div", {
          staticClass: "modal-body__btn-close has-link",
          on: { click: _vm.close },
        }),
        _vm._v(" "),
        _c("p", { staticClass: "modal-title" }, [
          _vm._v("브라우저 지원 종료 안내"),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "modal-contents" }, [
          _c("img", { attrs: { src: _vm.assetPath, alt: "Logo of ie" } }),
          _vm._v(" "),
          _vm._m(0),
        ]),
        _vm._v(" "),
        _c("p", { staticClass: "modal-desc" }, [
          _vm._v(
            "패스트캠퍼스를 계속 이용하려면 지원되는 브라우저로 전환해야 합니다."
          ),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "modal-btns" }, [
          _c("button", { on: { click: _vm.goBrowserLinkPage } }, [
            _vm._v("다운로드 받으러 가기"),
          ]),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [
      _vm._v("Internet Explorer 브라우저에 대한 지원이"),
      _c("br"),
      _vm._v("2021년 4월 21일에 종료됩니다."),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }